export enum PROBLEMS_STUB_SIZE {
    L = 'L',
    XL = 'XL',
}
